import React, { useState } from "react";
import { formatUnderlyingPair } from "./optionsDataHelpers";

function fmtPrice(price) {
  const n = Number(price);
  if (!Number.isFinite(n) || n <= 0) return "—";
  return n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export default function OptionsTickerChip({
  underlying,
  symbol,
  iconPath,
  price,
  isActive = false,
  expiryCount = 0,
  onClick,
  onIconError,
}) {
  const [showTip, setShowTip] = useState(false);
  const pairLabel = formatUnderlyingPair(underlying);

  return (
    <div
      className={`options-ticker-item${isActive ? " active" : ""}`}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => { if (e.key === "Enter" || e.key === " ") onClick(); } : undefined}
    >
      <img
        src={iconPath}
        alt={symbol || underlying}
        className="options-ticker-coin-img"
        onError={onIconError}
      />
      <div className="options-ticker-info">
        <div className="options-ticker-top">
          <span className="options-ticker-symbol">{underlying}</span>
          <span
            className="options-ticker-info-wrap"
            onMouseEnter={() => setShowTip(true)}
            onMouseLeave={() => setShowTip(false)}
            onClick={(e) => e.stopPropagation()}
          >
            <i className="ri-information-fill options-ticker-info-icon" aria-hidden="true" />
            {showTip && (
              <div className="options-ticker-info-tip" role="tooltip">
                <div className="options-ticker-info-tip__title">{pairLabel} Options</div>
                <p className="options-ticker-info-tip__text">
                  European-style call and put contracts on {pairLabel} index price.
                  PnL and margin use the live index; select an expiry below to view the chain.
                </p>
                <div className="options-ticker-info-tip__row">
                  <span>Index price</span>
                  <span>{price > 0 ? `${fmtPrice(price)} USDT` : "—"}</span>
                </div>
                <div className="options-ticker-info-tip__row">
                  <span>Listed expiries</span>
                  <span>{expiryCount > 0 ? expiryCount : "—"}</span>
                </div>
                <div className="options-ticker-info-tip__row">
                  <span>Contract size</span>
                  <span>1 Cont = 1 {underlying}</span>
                </div>
              </div>
            )}
          </span>
        </div>
        <div className="options-ticker-bottom">
          <span className="options-ticker-price">{fmtPrice(price)}</span>
        </div>
      </div>
    </div>
  );
}
